import { intersection, isEmpty } from 'lodash'

/**
 * Decide si mostrar preroll (VAST/VMAP) para un contenido específico (MGO-E84).
 *
 * Regla de negocio (ads-por-contenido-design-web.md §4):
 * 1. Cruza los planIds del contenido contra los planes activos del usuario.
 * 2. Si ningún plan del usuario cubre el contenido ⇒ true (comportamiento actual;
 *    el candado de acceso decide si el contenido pagado se bloquea).
 * 3. Si algún plan que da acceso tiene hasAds === false ⇒ sin preroll (false).
 * 4. Si todos los planes que dan acceso tienen ads (true o undefined) ⇒ con preroll (true).
 *
 * Nota: decide SOLO el preroll. El DAI live es independiente (DA-001).
 * Solo el booleano `false` apaga ads; cualquier otro valor cuenta como con-ads.
 *
 * @param {string[]} contentPlanIds - planIds que dan acceso al contenido reproducido.
 * @param {string[]} subscriptionsPlanIds - planIds de todos los planes activos del usuario.
 * @param {Object.<string, boolean>} planIdToHasAds - mapa plan_id → hasAds (true = con ads).
 * @returns {boolean} true = mostrar preroll; false = sin preroll.
 */
export const shouldShowAds = (contentPlanIds, subscriptionsPlanIds, planIdToHasAds) => {
  const relevantPlanIds = intersection(subscriptionsPlanIds, contentPlanIds || [])
  if (isEmpty(relevantPlanIds)) return true
  return !relevantPlanIds.some(id => planIdToHasAds[id] === false)
}
